import { Component } from '@angular/core';
import { HomeHeadingContianerComponent } from '../home-heading-contianer/home-heading-contianer.component';
import { ProfileStripSummaryComponent } from '../profile-strip-summary/profile-strip-summary.component';
import { MulticitySearchEngineComponent } from '../../../search-engine/components/multicity-search-engine/multicity-search-engine.component';
import { TravelComfortComponent } from '../travel-comfort/travel-comfort.component';

@Component({
    selector: 'app-multicity-dashboard-tab-layout',
    templateUrl: './multicity-dashboard-tab-layout.component.html',
    styleUrls: ['./multicity-dashboard-tab-layout.component.scss'],
    imports: [HomeHeadingContianerComponent, ProfileStripSummaryComponent, MulticitySearchEngineComponent, TravelComfortComponent]
})
export class MulticityDashboardTabLayoutComponent {
  constructor() {
  }
}
